import React, { useEffect, useState } from "react";
import { ChangeTitle, toAbsoluteUrl } from "../../helpers/Reusable";
import Switch from "react-switch";
import { apiHeader, getData, postData } from "../../helpers/ApiHelper";

const ManageNewsLetter = () => {
  ChangeTitle("Manage Newsletter");
  const [selectedNewsletter, setSelectedNewsletter] = useState([]);
  console.log("selectedNewsletter", selectedNewsletter);

  // Newsletter Add
  const addNewsletter = async (id) => {
    const param = {
      manageNewsLetter: id,
    };
    var response = await postData(
      "private/newsletter/manage/set",
      param,
      apiHeader(false)
    );

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      getNewsletter();
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  // Function to toggle selection and update API
  const handleToggle = async (id) => {
    let updatedSelections = [];

    if (Array.isArray(selectedNewsletter) && selectedNewsletter.includes(id)) {
      // Remove from selection if already present
      updatedSelections = selectedNewsletter.filter((pid) => pid !== id);
    } else {
      // Add to selection if not present
      updatedSelections = Array.isArray(selectedNewsletter)
        ? [...selectedNewsletter, id]
        : [id];
    }

    setSelectedNewsletter(updatedSelections);
    console.log("updatedSelections", updatedSelections);

    // Send updated array to the API
    await addNewsletter(updatedSelections);
  };

  // Newsletter Selected Get
  const getNewsletter = async () => {
    const param = {};
    var response = await getData(
      "private/newsletter/manage/get",
      param,
      apiHeader(false)
    );

    console.log("|||||||||", response);

    if (
      String(response?.status) == "200" &&
      String(response?.data.status) == "200"
    ) {
      const data = response.data.data;
      setSelectedNewsletter(data.manageNewsLetter);
    } else {
      console.log(response.data);
      console.log(response.data.message);
    }
  };

  useEffect(() => {
    getNewsletter();
  }, []);

  return (
    <>
      <div className="w-full p-[5%] min-h-screen bg-yellow">
        <div className="xxl:container mx-auto">
          <div className="w-full mb-[5%] md:mb-[2%]">
            <h1 className="hanson text-center mb-[1%] heading">
              Manage newsletter
            </h1>
            <img
              className="mb-[2%] mx-auto"
              src={toAbsoluteUrl("media/img/titledesign/t-yellow.svg")}
              alt=""
            />
          </div>
          <div className="w-full">
            <div className="flex gap-5 mb-[3rem] justify-between items-center p-[1.5rem] lg:p-[3rem] manage-interest-box">
              <div>
                <h1 className="mib-title">Daily whatsapp update</h1>
                <p className="mib-title2">
                  Get daily updates on new case laws, circulars, notifications,
                  and articles delivered to your inbox. Stay informed.
                </p>
              </div>
              <div>
                <Switch
                  checked={
                    Array.isArray(selectedNewsletter) &&
                    selectedNewsletter.includes(1)
                  }
                  onChange={() => handleToggle(1)}
                  onColor="#c99930"
                  offColor="#E6E6E6"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  handleDiameter={20}
                  height={24}
                  width={48}
                />
              </div>
            </div>
            <div className="flex gap-5 justify-between items-center p-[1.5rem] lg:p-[3rem] manage-interest-box">
              <div>
                <h1 className="mib-title">Weekly digest</h1>
                <p className="mib-title2">
                  Get weekly updates on new case laws, circulars, notifications,
                  and articles delivered to your inbox. Stay informed.
                </p>
              </div>
              <div>
                <Switch
                  checked={
                    Array.isArray(selectedNewsletter) &&
                    selectedNewsletter.includes(2)
                  }
                  onChange={() => handleToggle(2)}
                  onColor="#c99930"
                  offColor="#E6E6E6"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  handleDiameter={20}
                  height={24}
                  width={48}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageNewsLetter;
